import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import * as echarts from "echarts/core";
// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from "echarts/charts";
import { TooltipComponent, LegendComponent, GridComponent, DatasetComponent, TransformComponent, } from "echarts/components";
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
import { getColumnStudayData, getColumnStudayList, getColumnStudayCount } from '@/api/statistics';
import { getEnabledColumnList } from '@/api/student';
import { mixin_export } from '@/utils/exportFile';
// 注册必须的组件
echarts.use([
    TooltipComponent,
    LegendComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    LineChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer,
]);
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.instance = null;
        this.chartType = "last30";
        this.searchColumnId = '';
        this.columnList = [];
        this.chartTime = [
            dayjs()
                .subtract(29, "day")
                .format("YYYY-MM-DD"),
            dayjs().format("YYYY-MM-DD"),
        ];
        this.search = {
            keywordType: '1',
            keyword: ''
        };
        this.allStudyUsers = '0';
        this.tableData = [];
        this.total = 0;
        this.pageNo = 1;
        this.pageSize = 15;
    }
    changeChart() {
        this.getData();
    }
    created() {
        this.getColumnList();
    }
    mounted() {
        this.initChart();
    }
    onSearch() {
        this.search.keyword = '';
        this.pageNo = 1;
        this.getStudyCount();
        this.getData();
        this.getList();
    }
    async getStudyCount() {
        if (this.searchColumnId === '')
            return;
        let res = await getColumnStudayCount(this.searchColumnId);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.allStudyUsers = res.data.data.allStudyUsers || 0;
    }
    async getColumnList() {
        let res = await getEnabledColumnList();
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.columnList = res.data.data || [];
    }
    async getData() {
        if (this.searchColumnId === '')
            return this.$message.error('请选择专栏');
        let data = {
            courseId: this.searchColumnId,
            startTime: this.chartTime[0],
            endTime: this.chartTime[1]
        };
        const res = await getColumnStudayData(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.renderChart(res.data.data || []);
    }
    onChangeTime(value) {
        this.chartTime = value;
    }
    onChangeType(value) {
        switch (value) {
            case "yesterday":
                this.chartTime = [
                    dayjs()
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"),
                    dayjs()
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"),
                ];
                break;
            case "today":
                this.chartTime = [
                    dayjs().format("YYYY-MM-DD"),
                    dayjs().format("YYYY-MM-DD"),
                ];
                break;
            case "last7":
                this.chartTime = [
                    dayjs()
                        .subtract(6, "day")
                        .format("YYYY-MM-DD"),
                    dayjs().format("YYYY-MM-DD"),
                ];
                break;
            case "last30":
                this.chartTime = [
                    dayjs()
                        .subtract(29, "day")
                        .format("YYYY-MM-DD"),
                    dayjs().format("YYYY-MM-DD"),
                ];
                break;
            case "custom":
                this.$refs.chartPicker.focus();
                break;
            default:
                break;
        }
    }
    initChart() {
        var chartDom = document.getElementById("main");
        this.instance = echarts.init(chartDom);
        const option = {
            tooltip: {
                trigger: "axis",
            },
            legend: {
                data: ["学习人次", "平均学习时长（分钟）"],
            },
            grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                boundaryGap: false,
                data: [],
            },
            yAxis: {
                type: "value",
            },
            series: [
                {
                    name: "学习人次",
                    type: "line",
                    data: [],
                    smooth: true,
                },
                {
                    name: "平均学习时长（分钟）",
                    type: "line",
                    data: [],
                    smooth: true,
                }
            ],
        };
        this.instance.setOption(option);
    }
    renderChart(data) {
        if (this.instance) {
            const date = data.map((item) => {
                const month = item.day.split("-")[1];
                const day = item.day.split("-")[2];
                return `${month}-${day}`;
            });
            const studyUserCount = data.map((item) => item.studyUserCount);
            const studyTimeAvgMin = data.map((item) => item.studyTimeAvgMin);
            this.instance.setOption({
                xAxis: {
                    data: date,
                },
                series: [
                    {
                        data: studyUserCount,
                    },
                    {
                        data: studyTimeAvgMin,
                    }
                ],
            });
        }
    }
    onSearchList() {
        this.pageNo = 1;
        this.getList();
    }
    async getList() {
        if (this.searchColumnId === '')
            return this.$message.error('请选择专栏');
        let data = {
            courseId: this.searchColumnId,
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            keywordType: this.search.keywordType,
            keyword: this.search.keyword,
        };
        const res = await getColumnStudayList(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list;
        this.total = Number(res.data.data.total);
        this.pageNo = Number(res.data.data.pageNum);
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getList();
    }
    changePageSize(pageSize) {
        this.pageSize = pageSize;
        this.getList();
    }
    onExportStudyDetails() {
        if (this.searchColumnId === '')
            return this.$message.error('请选择专栏');
        this.$confirm('是否确认导出学习详情？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                courseId: this.searchColumnId,
                courseType: 1,
                keyword: this.search.keyword,
                keywordType: this.search.keywordType
            };
            mixin_export('/courseAdmin/userProgress/exportCourseUserProgressStatistic', 'get', data);
        });
    }
};
tslib_1.__decorate([
    Watch("chartTime")
], Login.prototype, "changeChart", null);
Login = tslib_1.__decorate([
    Component
], Login);
export default Login;
